// src/store.js
import { configureStore } from '@reduxjs/toolkit';
import userReducer from '../Store/userslice';

const store = configureStore({
  reducer: {
    user: userReducer,
  },
});

export default store;
